import FormProcessingSteps from "./form-steps";

const CheckEligibility = () => {
  return (
    <div className={'w-full h-[100vh] flex item-center justify-center'}>
      <FormProcessingSteps />
    </div>
  );
};

export default CheckEligibility;
